import * as React from 'react';
import { useState, useEffect } from "react";
import "./UserInfo.css";
import { getSessionStorage } from "../../../utils/sessionStorage";


export default function UserInfo() {

    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');

    useEffect(() => {
        var user = getSessionStorage("user");
        setEmail(user.email.toLowerCase())
        setNome(user.name)
    }, []);
    
return (
<div >
    <p className="titulo-principal-user-info">{nome}</p>
    <p className="sub-titulo-principal-user-info">{email}</p>
</div>

);
}